import { useMemo } from 'react';
import { t } from '@lingui/core/macro';

interface UseReadingTimeProps {
  reading_time: number | string;
}

export function useReadingTime({ reading_time }: UseReadingTimeProps) {
  const readTimeText = useMemo(() => {
    // Format word count (e.g., "3 min read" or "10 min read")
    const wordCount =
      typeof reading_time === 'number'
        ? reading_time
        : typeof reading_time === 'string'
          ? parseInt(reading_time, 10) || 0
          : 0;

    const readTime = Math.ceil(wordCount / 200); // Rough estimate: 200 words per minute
    return readTime <= 0 ? '' : t`${readTime} min read`;
  }, [reading_time]);

  return readTimeText;
}
